import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

const primaryColor = '#262AFF';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: primaryColor,
            100: primaryColor,
            200: primaryColor,
            300: primaryColor,
            400: primaryColor,
            500: primaryColor,
            600: primaryColor,
            700: primaryColor,
            800: primaryColor,
            900: primaryColor,
            950: primaryColor,
        },
        colorScheme: {
            light: {
                highlight: {
                    color: '#fff',
                    hoverColor: '#fff',
                    activeColor: '#fff',
                    focusColor: '#fff',
                },
                formField: {
                    invalidBorderColor: '#E63257',
                    invalidPlaceholderColor: '#909090',
                },
            },
            dark: {
                highlight: {
                    color: '#fff',
                    hoverColor: '#fff',
                    activeColor: '#fff',
                    focusColor: '#fff',
                },
                formField: {
                    invalidBorderColor: '#E63257',
                    invalidPlaceholderColor: '#909090',
                },
            },
        },
    },
    components: {
        accordion: {
            colorScheme: {
                light: {
                    content: {
                        background: 'transparent',
                    },
                },
                dark: {
                    content: {
                        background: 'transparent',
                    },
                },
            },
        },
    },
});

export default MyPreset;
